<!--
 * @Author: nsj
 * @Date: 2021-03-03 09:36:03
 * @Description: description
-->
<template>
  <div class="newCase">
    <div class="header">
      <Steps :current="current">
        <Step title="基本信息"></Step>
        <Step title="病史"></Step>
        <Step title="临床资料"></Step>
        <Step title="选择/提交"></Step>
      </Steps>
    </div>
    <div class="baseInfo" v-if="baseInfo">
      <h2>个人信息</h2>
      <div class="box">
        <div style="margin-bottom: 6px">
          患者姓名<i style="color: red">*</i>
        </div>
        <Input v-model="patientName" style="width: 400px" />
      </div>
      <div class="box">
        <div style="margin-bottom: 6px">
          患者性别<i style="color: red">*</i>
        </div>
        <RadioGroup v-model="sex" style="width: 400px">
          <Radio label="男" style="margin-right: 64px"></Radio>
          <Radio label="女"></Radio>
        </RadioGroup>
      </div>
      <div class="box">
        <div style="margin-bottom: 6px">
          患者年龄<i style="color: red">*</i>
        </div>
        <InputNumber
          :min="1"
          :precision="0"
          style="width: 400px"
          v-model="patientAge"
        ></InputNumber>
      </div>
      <div class="box">
        <div style="margin-bottom: 6px">身高</div>
        <Input v-model="stature" style="width: 400px">
          <span slot="append">cm</span>
        </Input>
      </div>
      <div class="box">
        <div style="margin-bottom: 6px">体重</div>
        <Input v-model="weight" style="width: 400px">
          <span slot="append">kg</span>
        </Input>
      </div>
      <div class="box">
        <div style="margin-bottom: 6px">民族</div>
        <Select v-model="nation" style="width: 400px">
          <Option value="汉族">汉族</Option>
          <Option value="壮族">壮族</Option>
          <Option value="回族">回族</Option>
          <Option value="满族">满族</Option>
          <Option value="蒙古族">蒙古族</Option>
          <Option value="其他">其他</Option>
        </Select>
      </div>
      <div class="box">
        <div style="margin-bottom: 6px">职业</div>
        <Select v-model="occupation" :transfer="true" style="width: 400px">
          <Option
            v-for="item in occupationArr"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
      </div>
      <div class="box">
        <div style="margin-bottom: 6px">婚姻状况</div>
        <Select v-model="maritalStatus" style="width: 400px" :transfer="true">
          <Option value="未婚">未婚</Option>
          <Option value="已婚">已婚</Option>
          <Option value="其他">其他</Option>
        </Select>
      </div>
      <div class="box">
        <div style="margin-bottom: 6px">检查系统</div>
        <Select v-model="auditingSystem" style="width: 400px" :transfer="true">
          <Option
            v-for="item in systemName"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
      </div>
      <div class="box">
        <div style="margin-bottom: 6px">主诉<i style="color: red">*</i></div>
        <Input
          v-model="action"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 4 }"
          style="width: 400px"
        />
      </div>
    </div>
    <!-- 病史 -->
    <div class="medicalHistory" v-show="model">
      <Spin size="large" fix v-if="loading">
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        <div>图片上传中</div>
      </Spin>
      <div class="describe" style="margin: 20px 40px">
        <span>病史描述：</span>
        <Input
          v-model="bingshi"
          type="textarea"
          :autosize="{ minRows: 10, maxRows: 10 }"
          style="margin-top: 12px"
        />
      </div>
      <span style="margin: 12px 40px; font-weight: 900; color: #2d8cf0"
        >上传图片：</span
      >
      <div class="picBox" style="margin: 12px 40px 12px; width: 100%">
        <div class="up">
          <Upload
            ref="upload2"
            :show-upload-list="false"
            :on-success="handleSuccess2"
            :format="['jpg', 'jpeg', 'png']"
            :max-size="2048"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="beforeUpload"
            multiple
            type="drag"
            :action="uploadfileUrl"
            style="display: inline-block; width: 104px"
          >
            <div
              style="
                width: 104px;
                height: 104px;
                line-height: 120px;
                text-align: center;
              "
            >
              <Icon type="ios-add" size="100"></Icon>
            </div>
          </Upload>
        </div>
        <div class="professionalimg">
          <viewer :images="bingshiPic" class="viewer">
            <div v-for="(item, index) in bingshiPic" :key="index" class="Photo">
              <img :src="item" />
              <Icon
                type="md-close"
                size="20"
                style="
                  position: absolute;
                  cursor: pointer;
                  background: #000;
                  border-radius: 50%;
                  opacity: 0.7;
                "
                @click="DelBs(item)"
              ></Icon>
            </div>
          </viewer>
        </div>
      </div>
      <span style="margin: 24px 40px; font-weight: 900; color: #2d8cf0"
        >上传附件:</span
      >
      <div class="accBox" style="margin: 12px 40px 0; width: 100%">
        <Upload
          ref="UploadBsAcc"
          :show-upload-list="false"
          multiple
          :action="uploadfileUrl"
          :on-success="handleSuccessBs"
          :on-format-error="handleFormatError1"
        >
          <Button icon="ios-cloud-upload-outline">上传</Button>
        </Upload>
        <div class="accCon" v-for="(item, index) in bsInfoAcc" :key="index">
          <span>{{ item.name }}</span>
          <div>
            <Button
              @click="delBsInfo(index)"
              style="margin-right: 12px"
              type="error"
              ghost
              >删除</Button
            >
            <Button @click="downloadFile(item.url)" type="primary">下载</Button>
          </div>
        </div>
      </div>
    </div>
    <!-- 临床资料 -->
    <div class="clinicalData" v-show="service">
      <div class="lcLeft">
        <Menu
          style="height: 720px"
          :theme="theme"
          @on-select="selectLc"
          :active-name="LcTab"
        >
          <MenuItem name="全部">全部</MenuItem>
          <MenuItem name="医院相关记录">医院相关记录</MenuItem>
          <MenuItem name="化验结果">化验结果</MenuItem>
          <MenuItem name="基因检测">基因检测</MenuItem>
          <MenuItem name="影像结果">影像结果</MenuItem>
          <MenuItem name="病理">病理</MenuItem>
          <MenuItem name="其他">其他</MenuItem>
        </Menu>
      </div>
      <div class="lcRight">
        <Button
          style="float: right; margin: 12px 12px 0 0"
          type="primary"
          @click="addLcAcc"
          >新增</Button
        >
        <div v-for="(item, index) in clinical" :key="index">
          <span style="color: #0165b8; font-weight: 700; font-size: 24px">{{
            item.year
          }}</span>
          <div
            v-for="(ite, index1) in item.data"
            :key="index1"
            class="recordList"
            @click="recordDetail(ite)"
          >
            <div class="box1">
              <div :style="{ background: renderColor(ite.Category) }">
                {{ ite.DateTime }}
              </div>
              <img :src="renderPic(ite.Category)" alt="" />
            </div>
            <div class="recordCon">
              {{ ite.EntryName }}
            </div>
            <Button
              @click.stop="delLcList(ite)"
              style="margin-left: 8px"
              type="info"
              ghost
              >删除</Button
            >
          </div>
        </div>
      </div>
      <Modal
        class-name="addData"
        v-model="addLc"
        title="添加资料"
        width="800"
        @on-cancel="cancelLc"
        :mask-closable="false"
      >
        <div>
          <span>
            检查时间<i style="color: red; margin-right: 4px">*</i>
            <DatePicker
              placeholder="请选择时间"
              v-model="checkTime"
              style="width: 212px"
            ></DatePicker>
          </span>
        </div>
        <div style="margin-top: 24px">
          <span>
            资料类别<i style="color: red; margin-right: 4px">*</i>
            <Select v-model="DataCategories" style="width: 212px">
              <Option
                v-for="(item, index) in DataCategorieList"
                :value="item"
                :key="index"
                >{{ item }}</Option
              >
            </Select>
          </span>
        </div>
        <div style="margin-top: 24px">
          <span>
            项目名称<i style="color: red; margin-right: 4px">*</i>
            <Input v-model="projectName" style="width: 212px" />
          </span>
        </div>
        <div style="margin-top: 24px">
          <span>
            项目结果
            <Input
              type="textarea"
              :autosize="{ minRows: 6, maxRows: 6 }"
              v-model="projectRes"
              style="width: 400px; margin-left: 6px"
            />
          </span>
        </div>
        <div style="margin: 24px 0 12px">
          资料图片
          <Spin size="large" fix v-if="loading">
            <Icon
              type="ios-loading"
              size="18"
              class="demo-spin-icon-load"
            ></Icon>
            <div>图片上传中</div>
          </Spin>
          <div class="picBox" style="margin: 12px 40px 0; width: 100%">
            <div class="up">
              <Upload
                ref="upload3"
                :show-upload-list="false"
                :on-success="handleSuccess3"
                :format="['jpg', 'jpeg', 'png']"
                :max-size="2048"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="beforeUpload"
                multiple
                type="drag"
                :action="uploadfileUrl"
                style="display: inline-block; width: 104px"
              >
                <div
                  style="
                    width: 104px;
                    height: 104px;
                    line-height: 120px;
                    text-align: center;
                  "
                >
                  <Icon type="ios-add" size="100"></Icon>
                </div>
              </Upload>
            </div>
            <div class="professionalimg">
              <viewer :images="lcInfoPic" class="viewer">
                <div
                  v-for="(item, index) in lcInfoPic"
                  :key="index"
                  class="Photo"
                >
                  <img :src="item" />
                  <Icon
                    type="md-close"
                    size="20"
                    style="
                      position: absolute;
                      cursor: pointer;
                      background: #000;
                      border-radius: 50%;
                      opacity: 0.7;
                    "
                    @click="DelLc(item)"
                  ></Icon>
                </div>
              </viewer>
            </div>
          </div>
        </div>
        <span>上传附件:</span>
        <div class="accBox" style="margin: 12px 40px 24px; width: 100%">
          <div class="up">
            <Upload
              :show-upload-list="false"
              ref="UploadAcc"
              multiple
              :action="uploadfileUrl"
              :on-success="handleSuccess"
              :on-format-error="handleFormatError1"
            >
              <Button icon="ios-cloud-upload-outline">上传</Button>
            </Upload>
          </div>
          <div class="accCon" v-for="(item, index) in lcInfoAcc" :key="index">
            <span>{{ item.name }}</span>
            <div>
              <Button
                size="small"
                @click="delLcInfo(index)"
                style="margin-right: 12px"
                type="error"
                ghost
                >删除</Button
              >
              <Button
                size="small"
                @click="downloadFile(item.url)"
                type="primary"
                >下载</Button
              >
            </div>
          </div>
        </div>
        <div class="dicom">
          <div style="width: 20%">
            <p>影像图片(Dicom)</p>
            <input
              type="file"
              id="filed"
              hidden=""
              accept=".dcm"
              @change="filePreview"
              multiple="multiple"
            />
            <Button style="margin: 12px 0 0 36px" @click="uploadPic"
              >上传图像</Button
            >
          </div>
          <div style="cursor: pointer; width: 25%" v-if="IsShowUpload">
            <p>
              <Icon size="30" color="#1890FF" type="md-cloud-outline" />上传
            </p>
            <div>
              <p v-if="uploading">
                上传中请等待<Icon
                  type="ios-loading"
                  size="18"
                  class="demo-spin-icon-load"
                ></Icon>
              </p>
              <div v-else>
                <p>上传完成，已上传{{ dicomNum }}张</p>
                <p>成功{{ uploadSuccessNum }}张，失败{{ uplaodFaildNum }}张</p>
              </div>

              <p v-if="uploadFaild">上传失败，请尝试重新上传</p>
            </div>
          </div>
          <div
            class="border1"
            :style="{
              borderColor: IsShowSwitch
                ? '#ccc'
                : transformationSuccess
                ? '#1890FF'
                : '',
            }"
            v-if="IsShowUpload"
          ></div>
          <div style="cursor: pointer; width: 25%" v-if="IsShowUpload">
            <p>
              <Icon
                size="30"
                :style="{ color: IsShowSwitch ? '#ccc' : '#1890FF' }"
                type="md-sync"
              />转换
            </p>
            <div>
              <p v-if="transformation">
                转换中请等待<Icon
                  type="ios-loading"
                  size="18"
                  class="demo-spin-icon-load"
                ></Icon>
              </p>
              <div v-if="transformationSuccess">
                <p>转换完成，已转换{{ zhDicomNum }}张</p>
                <p>成功{{ zhSuccessDicom }}张，失败{{ zhFaildDicom }}张</p>
              </div>
              <p v-if="transformationFaild">转换失败，请尝试重新转换</p>
            </div>
          </div>
          <div
            class="border2"
            :style="{
              borderColor: !transformationSuccess ? '#ccc' : '#1890FF',
            }"
            v-if="IsShowUpload"
          ></div>
          <div v-if="IsShowUpload" style="">
            <p>
              <Icon
                size="30"
                :style="{ color: !transformationSuccess ? '#ccc' : '#1890FF' }"
                type="md-checkmark-circle-outline"
              />完成
            </p>
            <Button v-if="transformationSuccess" type="primary" @click="lookPic"
              >查看图像</Button
            >
          </div>
        </div>
        <div slot="footer">
          <Button type="primary" @click="lcSure">确定</Button>
        </div>
      </Modal>
    </div>
    <div class="submit" v-if="front">
      <div class="team">
        <span style="margin-right: 24px">选择要提交的专家团队</span>
        <Select v-model="teamInfo" style="width: 200px" :disabled="readonly">
          <Option
            v-for="(item, index) in teamName"
            :value="item.CenterID"
            :key="index"
            >{{ item.Team }}</Option
          >
        </Select>
      </div>
    </div>
    <div class="agree" v-if="step == '确认提交'">
      <Checkbox v-model="isagreen">
        阅读并同意<a @click="fullmodal = true">平台知情同意书</a></Checkbox
      ><br />
    </div>
    <Modal v-model="fullmodal" fullscreen title="平台知情同意书">
      <Pdf></Pdf>
      <div slot="footer">
        <Button @click="okbook('n')">取消</Button>
        <Button type="primary" @click="okbook('y')">同意</Button>
      </div>
    </Modal>
    <div ref="finish" class="footer">
      <Button type="primary" @click="lastStep" class="lastBtn" v-model="last"
        >上一页</Button
      >
      <Button type="primary" @click="next" class="nextBtn">{{ step }}</Button>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import Request from "../utils/request";
import Config from "../config/index";
const newCase = Config.SXG_baseUrl + "/api/currency/UpdateRecord"; //新建案例的个人信息
const getMedicalHistory = Config.SXG_baseUrl + "/api/currency/UpdateRecord"; //新建病史
const getClinicalData = Config.SXG_baseUrl + "/api/currency/UpdateRecord"; //新建临床资料
const getTeam = Config.SXG_baseUrl + "/api/casemanager/GetCenterList"; //获取团队名称列表
const submitTeam = Config.SXG_baseUrl + "/api/casemanager/UpdateCaseByCenter"; //提交案例到中心团队
const submitTeamToTa = Config.SXG_baseUrl + "/api/casemanager/UpdateCaseByDoc"; //向ta提交案例
const GetnewCaseHistory = Config.SXG_baseUrl + "/api/casemanager/AddOperation"; //新建案例的操作历史
const GetCaseClinical = Config.SXG_baseUrl + "/api/casemanager/GetCaseClinical"; //获取临床资料信息
const GetCaseHistory = Config.SXG_baseUrl + "/api/currency/GetRecordDetail"; //获取病史信息
const DeleteRecord = Config.SXG_baseUrl + "/api/currency/DeleteRecord"; //删除临床资料列表
const getDicomNum = Config.SXG_baseUrl + "/api/casemanager/GetDicomFile"; //获取dicom文件转换数量
import Pdf from "../components/pdf.vue";
import Base64 from "base-64";
import {
  Steps,
  Step,
  Button,
  Input,
  RadioGroup,
  Radio,
  Select,
  Option,
  Form,
  FormItem,
  Row,
  Col,
  Upload,
  Poptip,
  Icon,
  Modal,
  Spin,
  Menu,
  MenuItem,
  DatePicker,
  InputNumber,
  Checkbox,
} from "view-design";
export default {
  components: {
    Steps,
    Step,
    Button,
    Input,
    RadioGroup,
    Radio,
    Select,
    Option,
    Form,
    FormItem,
    Row,
    Col,
    Upload,
    Poptip,
    Icon,
    Modal,
    Spin,
    Menu,
    MenuItem,
    DatePicker,
    InputNumber,
    Checkbox,
    Pdf,
  },
  data() {
    return {
      dicomUrl: "",
      dicomNum: 0,
      zhNum: 0,
      zhDicomNum: 0,
      zhSuccessDicom: 0,
      zhFaildDicom: 0,
      lcID: "", //新建临床资料的id
      uploadSuccessNum: 0,
      uplaodFaildNum: 0,
      transformation: false,
      transformationSuccess: false,
      IsShowSwitch: true,
      uploadFaild: false,
      transformationFaild: false,
      uploading: false,
      IsShowUpload: false,
      fullmodal: false,
      Stroge: JSON.parse(localStorage.getItem("Role")),
      joinApply: false,
      isagreen: false,
      BsId: "", //病史ID
      IsAdd: true, //新增临床资料标识
      ClinicalID: "", //每条临床资料的id
      LcTab: "全部",
      colors: [
        "#D4607B",
        "#158FE9",
        "#ECB147",
        "#5BBD00",
        "#F47451",
        "#009999",
      ],
      clinical: [], //临床资料详情
      bsInfoAcc: [], //病史附件
      lcInfoAcc: [], //临床资料附件
      readonly: false,
      theme: "light",
      projectRes: "",
      projectName: "",
      DataCategories: "", //资料类别
      DataCategorieList: [
        "医院相关记录",
        "化验结果",
        "基因检测",
        "影像结果",
        "病理",
        "其他",
      ], //资料类别列表
      checkTime: "",
      addLc: false,
      loading: false,
      uploadfileUrl: Config.SXG_baseUrl + "/api/currency/uploadfile",
      uploadDicom: Config.SXG_baseUrl + "/api/currency/uploadfile2",
      DelLcPic: "",
      DelBsPic: "",
      Img: "", //登陆人头像
      CaseID: "", //新建案例的id
      TeamID: "", //团队id
      CenterName: "", //团队名称
      CenterID: "",
      DocUserJid: "", //当前登录UserJid
      DocID: "", //当前登录医生ID
      DocName: "", //当前登录医生名字
      current: 0, //步骤条
      step: "下一页",
      last: true,
      baseInfo: true,
      model: false,
      service: false,
      front: false,
      patientName: "", //患者姓名
      sex: "", //患者性别
      patientAge: null, //患者年龄
      stature: "", //身高
      weight: "", //体重
      nation: "", //民族
      occupation: "", //职业
      occupationArr: [
        { label: "工人", value: "工人" },
        { label: "农民", value: "农民" },
        { label: "教师", value: "教师" },
        { label: "管理/科技人员", value: "管理/科技人员" },
        { label: "医务人员", value: "医务人员" },
        { label: "学生", value: "学生" },
        { label: "军人", value: "军人" },
        { label: "个体", value: "个体" },
        { label: "其它", value: "其它" },
      ],
      maritalStatus: "", //婚姻状况
      auditingSystem: "", //检查系统
      systemName: [
        { label: "运动系统", value: "运动系统" },
        { label: "消化系统", value: "消化系统" },
        { label: "呼吸系统", value: "呼吸系统" },
        { label: "泌尿系统", value: "泌尿系统" },
        { label: "生殖系统", value: "生殖系统" },
        { label: "内分泌系统", value: "内分泌系统" },
        { label: "免疫系统", value: "免疫系统" },
        { label: "神经系统", value: "神经系统" },
        { label: "循环系统", value: "循环系统" },
      ], //检查系统名称
      action: "", //主诉
      bingshi: "", //病史的描述
      isRemove1: false,
      modal_loading: false,
      isRemove3: false,
      bingshiPic: [], //渲染病史图片
      lcInfoPic: [], //渲染临床资料图片
      visible: false,
      imgName: "",
      teamInfo: "", //专家团队
      teamName: [], //专家团队名称
      TeamName: "",
      IsJoin: "",
      random: "",
      timer:''
    };
  },
  methods: {
    //选择上传的文件
    filePreview(e) {
      let files = e.target.files;
      let arr = Array.from(files);
      if (arr.length) {

        this.sendImages(arr);
      }
    },
    //上传文件到服务器
    sendImages(imageFiles) {
      this.random = Math.floor(Math.random() * 1000);
      // console.log()
      // this.DicomArr = []
      this.uploading = true;
      this.IsShowUpload = true;
      var _this = this;
      _this.uploadSuccessNum=0
      _this.uplaodFaildNum=0;
      clearInterval(_this.timer);
      return Promise.all(
        imageFiles.map((imageFile, index) => {
          return new Promise(function (resolve, reject) {
            let formData = new window.FormData();
            formData.append("files", imageFile);
            formData.append("CID", _this.lcID);
            formData.append("random", _this.random);
            Request.postRequest(_this.uploadDicom, formData).then((res) => {
              if (res.code == 200) {
                console.log(res);
                _this.dicomNum = imageFiles.length;
                _this.uploadSuccessNum++;
              } else {
                _this.uplaodFaildNum++;
              }
            //   console.log(_this.uploadSuccessNum,_this.uplaodFaildNum,123)
              if (_this.uplaodFaildNum == imageFiles.length) {
                  _this.uploading = false;
                  _this.IsShowSwitch = false;
                  return _this.$Message.info("上传失败");
                }
              if (index == imageFiles.length - 1) {
                _this.uploading = false;
                _this.IsShowSwitch = false;
                _this.transformation = true;
                _this.timer = setInterval(() => {
                  Request.getRequest(getDicomNum, {
                    CID: _this.lcID,
                    random: _this.random,
                  }).then((res) => {
                    if (res.code == 200) {
                      if (res.data.convert == imageFiles.length) {
                        clearInterval(_this.timer);
                        _this.zhDicomNum = res.data.convert;
                        _this.zhSuccessDicom = res.data.Success;
                        _this.zhFaildDicom = res.data.Fail;
                        _this.transformationSuccess = true;
                        _this.transformation = false;
                        _this.GetCaseClinical(_this.LcTab);
                      }
                    }
                  });
                }, 2000);
              }
            });
          });
        })
      );
    },

    //上传图像
    uploadPic() {
      if (!this.checkTime) {
        return this.$Message.info("请选择日期");
      } else if (!this.DataCategories) {
        return this.$Message.info("请选择资料类别");
      } else if (!this.projectName) {
        return this.$Message.info("请填写项目名称");
      }
      
      this.getClinicalData();
      document.getElementById("filed").click();
    },

    //查看dicom图像
    lookPic() {
      //   console.log(this.dicomUrl);
      window.open(
        "https://www.elismed.com:777/pacspc/index?StudyInstUID=" + this.dicomUrl
      );
    },

    okbook(which) {
      if (which == "y") {
        this.fullmodal = false;
        this.isagreen = true;
      } else if (which == "n") {
        this.fullmodal = false;
        this.isagreen = true;
      }
    },
    addLcAcc() {
      this.lcID = "";
      this.addLc = true;
      this.IsAdd = true;
      this.checkTime = "";
      this.DataCategories = "";
      this.projectName = "";
      this.projectRes = "";
      this.lcInfoPic = [];
      this.lcInfoAcc = [];
      this.$refs.UploadAcc.clearFiles();
    },
    //下载文件
    downloadFile(url) {
      let link = document.createElement("a");
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          link.href = URL.createObjectURL(blob);
          // console.log(link.href)
          link.download = "";
          document.body.appendChild(link);
          link.click();
        });
      link.style.display = "none";
      URL.revokeObjectURL(link.href); //释放掉blob对象
    },
    //新建案例临床资料
    getClinicalData() {
      let obj = {};
      if (this.IsAdd) {
        obj = {
          ID: this.lcID,
          tablename: "Clinical",
          CaseID: this.CaseID,
          Results: this.projectRes,
          ImgUrl: JSON.stringify(this.lcInfoPic),
          Year: dayjs(this.checkTime).format("YYYY"),
          DateTime: dayjs(this.checkTime).format("YYYY-MM-DD"),
          Category: this.DataCategories,
          EntryName: this.projectName,
          Annex: this.lcInfoAcc.length ? JSON.stringify(this.lcInfoAcc) : "[]", //附件
        };
      } else {
        obj = {
          ID: this.ClinicalID,
          tablename: "Clinical",
          CaseID: this.CaseID,
          Results: this.projectRes,
          ImgUrl: JSON.stringify(this.lcInfoPic),
          Year: dayjs(this.checkTime).format("YYYY"),
          DateTime: dayjs(this.checkTime).format("YYYY-MM-DD"),
          Category: this.DataCategories,
          EntryName: this.projectName,
          Annex: this.lcInfoAcc.length ? JSON.stringify(this.lcInfoAcc) : "[]", //附件
        };
      }
      Request.postRequest(getClinicalData, obj).then((res) => {
        if (res.code == 200) {
          this.IsAdd = true;
          console.log(res, "临床");
          this.lcID = res.data;
          if (this.LcTab == "全部") {
            this.GetCaseClinical("全部");
          } else {
            this.GetCaseClinical(this.DataCategories);
          }
        }
      });
    },
    //获取临床资料详情
    GetCaseClinical(IsTab) {
      Request.getRequest(GetCaseClinical, {
        CaseID: this.CaseID,
        Category: IsTab == "全部" ? "" : IsTab,
      }).then((res) => {
        if (res.code == 200) {
          this.LcTab = IsTab;
          this.$forceUpdate();
          console.log(res, "获取临床资料");
          res.data.map((item) => {
            item.color = this.randomColor();
            item.data.map((ite) => {
              ite.DateTime = dayjs(ite.DateTime).format("MM月DD日");
              this.dicomUrl = ite.StuyUID;
            });
          });
          this.clinical = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //随机颜色函数
    randomColor() {
      var str = Math.floor(Math.random() * this.colors.length);
      return this.colors[str];
    },
    //删除临床资料列表
    delLcList(data) {
      Request.postRequest(DeleteRecord, {
        ID: data.ID,
        tablename: "Clinical",
        type: "1",
      }).then((res) => {
        if (res.code == 200) {
          console.log("删除成功");
          this.GetCaseClinical(this.LcTab);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //新增临床资料记录
    lcSure() {
      if (this.checkTime == "") {
        return this.$Message.info("请选择检查时间");
      }
      if (this.DataCategories == "") {
        return this.$Message.info("请选择资料类别");
      }
      if (this.projectName == "") {
        return this.$Message.info("请输入项目名称");
      }
      this.addLc = false;
      this.number = 0;
      this.getClinicalData();
    },
    cancelLc() {
      this.addLc = false;
    },
    //临床资料记录详情
    recordDetail(data) {
      this.IsAdd = false;
      this.ClinicalID = data.ID;
      this.addLc = true;
      this.checkTime = `${data.Year}-${data.DateTime.split(/月|日/g)[0]}-${
        data.DateTime.split(/月|日/g)[1]
      }`;
      this.DataCategories = data.Category;
      this.projectName = data.EntryName;
      this.projectRes = data.Results;
      this.lcpic = data.ImgUrl == "" ? [] : JSON.parse(data.ImgUrl);
      this.lcInfoAcc = data.Annex == null || "" ? [] : JSON.parse(data.Annex);
    },
    //选择临床资料列表
    selectLc(name) {
      (this.LcTab = name), this.GetCaseClinical(name);
    },
    //下一步
    next() {
      if (this.patientName == "") {
        return this.$Message.error("请输入患者姓名");
      }
      if (this.sex == "") {
        return this.$Message.error("请选择性别");
      }
      if (this.patientAge == null) {
        return this.$Message.error("请输入年龄");
      }
      if (this.action == "") {
        return this.$Message.error("请输入主诉");
      }
      if (this.current == 0) {
        this.baseInfo = false;
        this.model = true;
        this.current++;
        //console.log(111111111, this.step);
        this.sureSubmit();
        //console.log(this.$refs.finish.innerText);
      } else if (this.current == 1) {
        this.baseInfo = false;
        this.model = false;
        this.service = true;
        this.current++;
        this.getMedicalHistory();
      } else if (this.current == 2) {
        this.baseInfo = false;
        this.model = false;
        this.service = false;
        this.front = true;
        this.current++;
        this.step = "确认提交";
      } else if (this.step == "确认提交") {
        if (this.teamInfo == "") {
          return this.$Message.info("请选择专家团队");
        } else if (this.isagreen == false) {
          return this.$Message.info("请阅读并同意平台知情同意书");
        } else {
          this.submitTeam();
          //   if (!this.IsJoin) {
          //     /* 如果还未申请 就弹出对话框 选择是否发起申请 */
          //     this.joinApply = true;
          //   } else {
          //     if (this.IsJoin == "T") {
          //       /* 如果申请过 并且 通过的话 存一下变量跳转页面*/

          //     } else if (this.IsJoin == "F") {
          //       return this.$Message.info("您已向团队发起申请，请耐心等待审核");
          //     }
          //   }
        }
      }
    },
    //上一步
    lastStep() {
      if (this.current == 0) {
        this.last = false;
        //console.log(this.$refs.finish.innerText);
      } else if (this.current == 1) {
        this.baseInfo = true;
        this.model = false;
        this.service = false;
        this.step = "下一页";
        this.current--;
      } else if (this.current == 2) {
        this.baseInfo = false;
        this.model = true;
        this.service = false;
        this.front = false;
        this.step = "下一页";
        this.current--; //获取一下病史
      } else if (this.current == 3) {
        this.baseInfo = false;
        this.model = false;
        this.service = true;
        this.front = false;
        this.step = "下一页";
        this.current--; //获取一下临床资料
        // this.GetCaseClinical("全部")
      }
    },
    /* ------------------------------------------------ */
    //病史删除附件
    delBsInfo(data) {
      this.bsInfoAcc.splice(data, 1);
    },
    //病史上传附件成功
    handleSuccessBs(response, file, fileList) {
      console.log(file);
      if (file.response.code == 200) {
        this.bsInfoAcc.push({ name: file.name, url: file.response.data[0] });
      } else {
        this.$Message.error(file.response.message);
      }
    },
    //病史上传图片成功的回调
    handleSuccess2(res) {
      if (res.code == 200) {
        this.bingshiPic.push(res.data[0]);
      }
      this.loading = false;
      // console.log(this.bingshiPic,11111)
    },

    //临床资料上传图片成功的回调
    handleSuccess3(res) {
      if (res.code == 200) {
        this.lcInfoPic.push(res.data[0]);
      }
      this.loading = false;
    },
    //临床资料上传附件成功的回调
    handleSuccess(response, file, fileList) {
      if (file.response.code == 200) {
        this.lcInfoAcc.push({ name: file.name, url: file.response.data[0] });
      } else {
        this.$Message.error(file.response.message);
      }
    },
    //临床资料删除附件
    delLcInfo(data) {
      this.lcInfoAcc.splice(data, 1);
    },
    handleFormatError1(file) {
      this.$Notice.warning({
        title: "文件格式不正确!",
        desc: file.name + "的文件格式不正确",
      });
    },
    //上传之前的回调
    beforeUpload() {
      this.loading = true;
    },
    //上传图片的大小
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "超过文件大小限制！",
        desc: file.name + "文件太大，不超过2M。",
      });
    },
    //上传图片失败的回调
    handleFormatError(file) {
      this.loading = false;
      this.$Notice.warning({
        title: "文件格式不正确!",
        desc: file.name + "的文件格式不正确，请选择jpg或png",
      });
    },

    //bs删除
    DelBs(item) {
      this.DelBsPic = item;
      this.isRemove1 = true;
      this.$Modal.confirm({
        title: "确定要删除吗？",
        onOk: (item) => {
          const fileList2 = this.bingshiPic;
          this.bingshiPic.splice(fileList2.indexOf(this.DelBsPic), 1);
        },
      });
    },

    //lc删除
    DelLc(item) {
      this.DelLcPic = item;
      this.isRemove3 = true;
      this.$Modal.confirm({
        title: "确定要删除吗？",
        onOk: (item) => {
          const fileList3 = this.lcInfoPic;
          this.lcInfoPic.splice(fileList3.indexOf(this.DelLcPic), 1);
        },
      });
    },

    /* ---------------------------------------------------------------------------------------------- */
    //获取团队名称列表
    getTeam() {
      Request.getRequest(getTeam, {
        tablename: "CenterHospital",
        fields: "ID CenterID,Team",
        UserJid: this.Stroge.UserJid,
      }).then((res) => {
        if (res.code == 200) {
          this.teamName = res.data;
          console.log(res.data, "获取团队名称列表");
          res.data.map((item) => {
            this.TeamID = item.CenterID;
            this.CenterName = item.Team;
          });
          if (!res.data.length) {
            return this.$Message.info(
              "您还没有申请通过的团队，暂时不能发起案例"
            );
          }
        }
      });
    },
    //新建案例的操作历史
    newCaseHistory() {
      Request.postRequest(GetnewCaseHistory, {
        CaseID: this.CaseID,
        Dynamic: `<span>${this.DocName}</span>新建案例<em>${this.patientName}</em>`,
        OperationHis: `<span>${this.DocName}</span>新建案例<em>${this.patientName}</em>`,
        OUserJid: this.DocUserJid,
        ODocName: this.DocName,
        Type: "新建案例",
        OImg: this.Img,
        CenterID: this.CenterID,
      }).then((res) => {
        if (res.code == 200) {
          console.log(res, "新建案例操作历史");
        }
      });
    },
    //新建案例的个人信息
    sureSubmit() {
      Request.postRequest(newCase, {
        tablename: "CaseList",
        ID: "",
        PatientName: this.patientName,
        Gender: this.sex,
        Age: this.patientAge,
        Height: this.stature,
        Weight: this.weight,
        Nation: this.nation,
        Marital: this.maritalStatus,
        Occupation: this.occupation,
        CheckSys: this.auditingSystem,
        Complaint: this.action,
        DocUserJid: this.DocUserJid,
        DocID: this.DocID,
        DocName: this.DocName,
      }).then((res) => {
        if (res.code == 200) {
          //   console.log(res, "CaseID");
          this.CaseID = res.data;
        }
      });
    },
    //新建案例病史
    getMedicalHistory() {
      Request.postRequest(getMedicalHistory, {
        ID: this.BsId ? this.BsId : "",
        tablename: "MedicalHistory",
        CaseID: this.CaseID,
        DiseaseContent: this.bingshi,
        DiseaseImg: JSON.stringify(this.bingshiPic),
        Annex: this.bsInfoAcc.length ? JSON.stringify(this.bsInfoAcc) : "[]", //病史附件
      }).then((res) => {
        if (res.code == 200) {
          //   console.log(res, "病史");
          this.BsId = res.data;
        }
      });
    },
    //获取临床资料
    GetCaseHistory() {
      Request.getRequest(GetCaseHistory, {
        tablename: "MedicalHistory",
        searchkey2: "CaseID",
        searchvalue2: this.CaseID,
      }).then((res) => {
        if (res.code == 200) {
          //   console.log(res, "病史");
          // this.bingshi =
          //   res.data.length != 0 ? res.data[0].DiseaseContent : "";
          // this.bingshiPic =
          //   res.data.length == 0
          //     ? []
          //     : res.data[0].DiseaseImg == ""
          //     ? []
          //     : JSON.parse(res.data[0].DiseaseImg);
          // this.bsInfoAcc = res.data[0].Annex == "" || res.data[0].Annex == null ? [] : JSON.parse(res.data[0].Annex)
        }
      });
    },
    //临床资料颜色
    renderColor(pic) {
      if (pic == "医院相关记录") {
        return "#737DFD";
      } else if (pic == "化验结果") {
        return "#FF8A80";
      } else if (pic == "基因检测") {
        return "#0088DE";
      } else if (pic == "影像结果") {
        return "#D4607B";
      } else if (pic == "病理") {
        return "#01BF95";
      } else if (pic == "其他") {
        return "#67C23A";
      }
    },
    //临床资料标识图
    renderPic(pic) {
      if (pic == "医院相关记录") {
        return require("../assets/yy.png");
      } else if (pic == "化验结果") {
        return require("../assets/hy.png");
      } else if (pic == "基因检测") {
        return require("../assets/jy.png");
      } else if (pic == "影像结果") {
        return require("../assets/yx.png");
      } else if (pic == "病理") {
        return require("../assets/bl.png");
      } else if (pic == "其他") {
        return require("../assets/qt.png");
      }
    },
    //提交案例到中心团队
    submitTeam() {
      this.teamName.map((item) => {
        if (this.teamInfo == item.CenterID) {
          this.TeamName = item.Team;
        }
      });
      let obj1 = {
        ID: this.CaseID,
        Status: 1,
        CenterID: this.$store.state.team.teamID,
        CenterName: this.$store.state.team.team,
        DocUserJid: this.$store.state.team.docUserjid,
        DocID: this.$store.state.team.docID,
        DocName: this.$store.state.team.docName,
      };
      let obj2 = {
        ID: this.CaseID,
        CenterID: this.teamInfo, //this.TeamID
        CenterName: this.TeamName,
        Status: 1,
      };
      Request.postRequest(
        this.$store.state.team.type == 2 ? submitTeamToTa : submitTeam,
        this.$store.state.team.type == 2 ? obj1 : obj2
      ).then((res) => {
        if (res.code == 200) {
          //   console.log(res, "提交案例到中心团队");
          this.$router.push("CaseDiscussion/tab_1");
          this.newCaseHistory(); //操作历史
          this.$forceUpdate();
          this.$Message.info("新建案例完成");
          Request.addLog("案例管理", "创建案例");
        } else {
          Request.addLog("案例管理", "创建案例", "F", res.message);
        }
      });
    },
  },
  created() {
    // console.log(this.$store.state.team,"崔忠梓存在vuex里的");
    if (this.$store.state.team.type != 0) {
      this.readonly = true;
      this.teamInfo = parseInt(this.$store.state.team.teamID);
      this.TeamName = this.$store.state.team.team;
    }
    this.$emit("funChangeTitle", "新建案例", "2-1");
    var stroge = localStorage.getItem("Role");
    this.CenterID = JSON.parse(stroge).CenterID;
    this.DocUserJid = JSON.parse(stroge).UserJid; //当前登录UserJid
    this.DocID = JSON.parse(stroge).ID; //当前登录医生ID
    this.DocName = JSON.parse(stroge).DocName; //当前登录医生名字
    this.Img = JSON.parse(stroge).ImgUrl;
  },
  mounted() {
    this.getTeam();
    this.bingshiPic = this.$refs.upload2.fileList;
    this.bingshiPic = [];
    this.lcInfoPic = this.$refs.upload3.fileList;
    this.lcInfoAcc = this.$refs.UploadAcc.fileList;
    this.bsInfoAcc = this.$refs.UploadBsAcc.fileList;
    this.bsInfoAcc = [];
    this.lcInfoAcc = [];
    this.lcInfoPic = [];
    this.IsJoin = this.$store.state.team.IsJoin;
  },
};
</script>

<style lang="less">
.newCase {
  .header {
    margin: 24px 24px 0;
  }
  .baseInfo {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .box {
      margin-top: 24px;
    }
  }
  .medicalHistory {
    //background: chartreuse;
    .describe {
      span {
        font-weight: 900;
        color: #2d8cf0;
      }
    }
    .picBox {
      display: flex;
      justify-content: flex-start;
      .up {
        margin-right: 20px;
      }
      .professionalimg {
        .viewer {
          display: flex;
          flex-wrap: wrap;
          .Photo {
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 12px;
            .ivu-icon-md-close {
              top: 0;
              right: 12px;
            }
            img {
              width: 100px;
              height: 100px;
              margin-right: 12px;
            }
          }
        }
      }
    }
    .accBox {
      .ivu-upload-list {
        display: flex;
        flex-wrap: wrap;
      }
      .accCon {
        border-radius: 8px;
        height: 50px;
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #f3f3f3;
        margin-top: 6px;
        width: 90%;
        span {
          font-size: 16px;
        }
      }
    }
  }
  .clinicalData {
    height: 100%;
    display: flex;
    justify-content: space-between;
    .lcRight {
      height: 720px;
      overflow-y: auto;
      padding-left: 24px;
      padding-top: 24px;
      flex: 1;
      .recordList {
        cursor: pointer;
        margin-top: 24px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 1px #e6e6e6 solid;
        padding-bottom: 12px;
        .box1 {
          display: flex;
          align-items: center;
          div {
            width: 50px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            // background: #158FE9;
            color: white;
          }
          img {
            width: 30px;
            height: 30px;
            margin-left: 12px;
          }
        }
        .recordCon {
          margin-left: 24px;
        }
      }
    }
  }
  .team {
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .agree {
    text-align: center;
    line-height: 21px;
    margin-top: 8px;
    user-select: none;
    .ivu-checkbox {
      margin-right: 7px;
    }
    .ivu-checkbox-inner {
      border-radius: 50%;
    }
    .ivu-checkbox-checked .ivu-checkbox-inner:after {
      border: 1px solid #2d8cf0;
      border-top: 0;
      border-left: 0;
    }
    .ivu-checkbox-checked .ivu-checkbox-inner {
      border-color: #dcdee2;
      background-color: transparent;
    }
    .ivu-checkbox-focus {
      box-shadow: none;
    }
  }
  .footer {
    display: flex;
    justify-content: center;
    margin: 18px 0;
    .lastBtn {
      margin-right: 64px;
    }
  }
}
//添加资料
.addData {
  .picBox {
    display: flex;
    justify-content: flex-start;
    .up {
      margin-right: 20px;
    }
    .professionalimg {
      .viewer {
        display: flex;
        flex-wrap: wrap;
        .Photo {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
          .ivu-icon-md-close {
            top: 0;
            right: 12px;
          }
          img {
            width: 100px;
            height: 100px;
            margin-right: 12px;
          }
        }
      }
    }
  }
  .accBox {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .ivu-upload-list {
      display: flex;
      flex-wrap: wrap;
    }
    .accCon {
      border-radius: 8px;
      height: 40px;
      padding: 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #f3f3f3;
      margin-top: 6px;
      width: 90%;
      span {
        font-size: 16px;
      }
    }
  }
  .dicom {
    width: 100%;
    display: flex;
    justify-content: space-between;
    position: relative;
    //   #1890FF
    .border1 {
      width: 120px;
      border-top: 1px solid #ccc;
      position: absolute;
      left: 294px;
      top: 15px;
    }
    .border2 {
      width: 120px;
      border-top: 1px solid #ccc;
      position: absolute;
      right: 108px;
      top: 15px;
    }
  }
}
.modal {
  display: flex;
  align-items: start;
  justify-content: center;
  top: 200px;
  .ivu-modal {
    width: 350px !important;
  }
  .ivu-modal-header-inner {
    text-align: center;
    font-weight: 800;
    font-family: "Microsoft Yahei";
  }
  .ivu-modal-header {
    border-bottom: none;
  }
  .ivu-modal-body {
    padding: 8px 50px 16px 50px;
    word-break: break-all;
  }
  .ivu-modal-footer {
    padding: 0;
    div {
      text-align: center;
      // border-top: none;
      display: flex;
      padding: 0;
    }
    .ivu-btn {
      width: 50%;
      height: 50px;
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
      background: #fff;
      border: none;
      color: #6f78f7;
      font-size: 16px;
    }
    .ivu-btn:nth-child(1) {
      border-right: 1px solid #eee;
    }
  }
  .ivu-icon-ios-close:before {
    display: none;
  }
}
</style>